<template>
  <div class="cls-list page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Custom Lot Sequence for Batch Lot Up V2')">
      <template v-slot:buttons>
        <add-new-button @click="onNewClick">
          <font-awesome-icon icon="plus-circle" class="icon"/>
          {{ $t('New CLS') }}
        </add-new-button>
      </template>
    </page-header>
    <div class="card content-wrapper p-2">
      <ClsTable/>
    </div>
    <cls-modal/>
  </div>
</template>

<script>
  import AddNewButton from "../../../core/components/common/AddNewButton";
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "../../../core/components/page-header/PageHeader";
  import ClsTable from "@/modules/setup/cls/ClsTable";
  import ClsModal from "@/modules/setup/cls/ClsModal";
  import {SOURCE_CLS_TABLE} from "@/modules/constants";

  const {mapActions} = createNamespacedHelpers('cls');
  export default {
    name: "Cls",
    components: {ClsModal, ClsTable, PageHeader, AddNewButton},
    methods: {
      ...mapActions(['showModal', 'updateTableSource']),
      onNewClick() {
        this.showModal({
          source: SOURCE_CLS_TABLE,
          object: {items: [{}]}
        })
      }
    },
    async beforeMount() {
      await this.updateTableSource({source: 'setup'});
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .cls-list {
    @include list-view-wrapper;
  }
</style>

